import { Grid } from "@mui/material";
import "./imageCarousel.scss";
import { IMAGE_CAROUSEL } from "../../../constant";

const ImageCarousel = () => {
  return (
    <div className="imageCarousel">
      <div className="image-container is-web-image">
        <img
          src={`${IMAGE_CAROUSEL.laptop}`}
          alt={`${IMAGE_CAROUSEL.laptop}`}
        />
      </div>
      <div className="image-container is-table-image">
        <img
          src={`${IMAGE_CAROUSEL.tablet}`}
          alt={`${IMAGE_CAROUSEL.tablet}`}
        />
      </div>
      <div className="image-container is-mobile-image">
        <img
          src={`${IMAGE_CAROUSEL.mobile}`}
          alt={`${IMAGE_CAROUSEL.mobile}`}
        />
      </div>
    </div>
  );
};

export default ImageCarousel;
